const flow = require('lodash/fp/flow');
const merge = require('lodash/merge');
const { format, subMonths } = require('date-fns');
const parseRequestMetaData = require('../../utils/parse-request-meta-data');
const base64 = require('base-64');

function getQS(parsedMetaData) {
  return {
    pfRelId: parsedMetaData.portfolio.pfRelId,
    branchCode: parsedMetaData.portfolio.branchCode
  };
}

function apiFactory({
  baseUrl,
  requestHandler,
}) {
  const headers = {
    'Content-Type': 'application/json',
  };
  const reqOpts = { headers, method: 'POST' };

  const requestArray = flow(
    requestHandler,
    x => x.catch(e => {
      if (e.statusCode === 404) return [];
      throw e;
    })
  );

  function getUrl(endpoint) {
    return `${baseUrl}${endpoint}`;
  }

  return {
    pushRegistration(inputs, metaData) {
      const url = getUrl('pushRegistration');
      const inputParams = inputs.split("#@#");
      const reqOpts = { headers, method: 'POST', json: true }
      const parsedMetaData = parseRequestMetaData(metaData);
      const body = {
        dwoUserId: parsedMetaData.qs.userId,
        deviceToken: inputParams[0],
        deviceId: inputParams[1],
        deviceOs: inputParams[2],
        deviceOsVersion: inputParams[3],
        tokenStatus: inputParams[4],
        tokenGenerateError: inputParams[5]
        
      };

      return requestHandler(merge(
        {},
        reqOpts,
        { url, body },
        parsedMetaData
      ));
    },

    getFCMSenderId(metaData) {
      const url = getUrl('getFCMSenderId');
      const reqOpts = { headers, method: 'POST', json: true }
      const parsedMetaData = parseRequestMetaData(metaData);
      const body = {};

      return requestHandler(merge(
        {},
        reqOpts,
        { url, body },
        parsedMetaData
      ));
    },
  };
}

module.exports = apiFactory;
